import { AssociarQRCodeRequest } from 'src/app/models/AssociarQRCodeRequest';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { ResponseBase } from '../models/response-base';
import { Reset } from '../models/reset';
import { Confirm } from '../models/confirm';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {
  API: string = environment.API + 'Portal/gestores';

  private recuperacao = new BehaviorSubject(null);
  currentRecuperacao = this.recuperacao.asObservable();

  changeRecuperacao(recuperacao: Confirm) {
    this.recuperacao.next(recuperacao);
  }

  constructor(private http: HttpClient) { }

  recuperar(reset: Reset): Observable<ResponseBase<any>> {
    return this.http.post<ResponseBase<any>>(`${this.API}/senha/recuperar`, reset);
  }

  confirmar(confirm: Confirm): Observable<ResponseBase<any>> {
    return this.http.post<ResponseBase<any>>(`${this.API}/senha/confirmar`, confirm);
  }

  ResetSenhaColaborador(associarQRCodeRequest: AssociarQRCodeRequest): Observable<ResponseBase<any>> {
    return this.http.post<ResponseBase<any>>(`${environment.API}Security/senha/reset/colaborador`, associarQRCodeRequest);
  }
}
